import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from 'angular2-toaster';
import { AuthService } from 'app/services/auth.service';
import { UserRepository } from 'app/services/database/user.repository';
import { DeviceService } from 'app/services/device.service';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { DeviceModel } from 'app/views/devices/models/device.model';

@Component({
    selector: 'psm-link-device',
    templateUrl: 'linkDevice.component.html',
    styleUrls: ['linkDevice.component.scss']
})

export class LinkDeviceComponent implements OnInit {

    // Prevents flickers
    public userHasDevices: boolean = true;

    public isWaiting: boolean;
    public step: number = 1;
    public deviceName;
    public devices: any[] = [];

    private deviceId: string;
    private user;
    private logger: Logger;

    constructor(
        private authService: AuthService,
        private deviceService: DeviceService,
        private userRepository: UserRepository,
        private toasterService: ToasterService,
        private translate: TranslateService,
        private loggerFactory: LoggerFactory
    ) {
        this.logger = loggerFactory.create('LinkDeviceComponent');
    }

    public async ngOnInit() {
        this.deviceName = await this.translate.get('modules.devices.link.unnamed-device');

        let user = await this.authService.getCurrentUser();
        let uid = user.uid;
        this.user = await this.userRepository.get(uid);

        if (this.user.devices !== undefined) {
            for (let deviceId of this.user.devices) {
                try {
                    let device = await this.deviceService.getDevice(deviceId);
                    this.devices.push({ key: deviceId, value: device });
                } catch (err) {
                    this.logger.error('An error occured while getting the user devices', err);
                }
            }
        }
        this.userHasDevices = this.devices.length > 0;
    }

    public onKeyDown(target: any, previous: any, current: any, next: any) {
        target.preventDefault();

        if (target.key === 'Backspace') {
            if (current.value === '') {
                if (previous) {
                    previous.focus();
                    previous.value = '';
                }
            } else {
                current.value = '';
            }
        } else if (!isNaN(target.key)) {
            current.value = target.key;
            if (next) {
                next.focus();
            }
        }
    }

    public async send(pin: string) {
        this.isWaiting = true;
        try {
            if (!await this.deviceService.validatePin(pin)) {
                this.toasterService.pop('error', undefined, 'errors.invalid-pin');
            } else {
                this.deviceId = await this.deviceService.linkDevice(pin);
                if (this.deviceId) {
                    this.step = 2;
                    this.toasterService.pop('success', undefined, 'modules.devices.link.link-success');
                    let device = await this.deviceService.getDevice(this.deviceId);
                    this.deviceName = device.name;
                } else {
                    this.toasterService.pop('error', undefined, 'errors.unable-to-link-device');
                }
            }
        } catch (err) {
            this.toasterService.pop('error', undefined, 'errors.unable-to-link-device');
        }

        this.isWaiting = false;
    }

    public async nameDevice(name: string) {
        this.isWaiting = true;

        if (this.deviceId === undefined) {
            this.toasterService.pop('error', undefined, 'errors.enter-a-pin-first');
            this.isWaiting = false;
            this.step = 1;
            return;
        }

        try {
            if (await this.deviceService.nameDevice(this.deviceId, name)) {
                this.toasterService.pop('success', undefined, 'modules.devices.link.naming-success');
            } else {
                this.toasterService.pop('error', undefined, 'errors.unable-to-name-device');
            }
        } catch (err) {
            this.toasterService.pop('error', undefined, 'errors.unable-to-name-device');
        }

        this.step = 3;
        this.isWaiting = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/devices/linkDevice.component.ts